import { Chip, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const CustomInputLabel = ({ label, head = false, sx }) => {
	const theme = useTheme();
	const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
	return (
		<Chip
			label={label}
			variant="outlined"
			sx={{
				width: '100%',
				justifyContent: 'start',
				fontWeight: head ? 600 : 400,
				bgcolor: head ? '#edf7ff' : '#f2f2f2',
				borderColor: '#e2ebf7',
				mb: matchDownSM ? 2 : 0,
				...sx,
			}}
		/>
	);
};

export default CustomInputLabel;
